"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zInspectionDetails = exports.zInspectionResult = exports.INSPECTION_RESULTS = void 0;
const zod_1 = require("zod");
exports.INSPECTION_RESULTS = ["pass", "fail"];
exports.zInspectionResult = zod_1.z.enum(exports.INSPECTION_RESULTS);
const zIsoDate = zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Use YYYY-MM-DD.");
/** What the shop records about one state-inspection line. Every field is optional:
 * the fee line works without any of it; `result` stays null until the test is done. */
exports.zInspectionDetails = zod_1.z.object({
    result: exports.zInspectionResult.nullable(),
    /** The paper Vehicle Inspection Report (VIR) / test record number. */
    virNumber: zod_1.z.string().trim().min(1).max(60).nullable(),
    inspectorTechnicianId: zod_1.z.number().int().positive().nullable(),
    inspectedOn: zIsoDate,
});
//# sourceMappingURL=inspections.js.map